const config = {
  nonprod: {
    idvaasUrl: "https://idvaas.sit-uk.worldreachsoftware.com",
    language: "en-CA",
    oldidvaasUrl: "https://sit.idvaas.worldreachsoftware.com/idvaasapi/",
  },
  prod: {
    idvaasUrl: "https://idvaas.uk.worldreachsoftware.com",
    language: "en-CA",
    oldidvaasUrl: "https://uk.idvaas.worldreachsoftware.com/idvaasapi/",
  },
};

const environment =
  process.env.REACT_APP_ENV ||
  (process.env.NODE_ENV === "production" ? "prod" : "nonprod");

export default config[environment];
